// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__11fQh","header":"styles_header__34i_v","title":"styles_title__2noz2","list":"styles_list__3112H","emptyState":"styles_emptyState__2TQsX"};